/*jshint esnext: true */
/*global jQuery, dis */

/* DIS/PLAY Script
 Author's name: Lars Munkholm
 Modified by:
 Client name: Danske Regioner
 Date of creation: 22.2.2016
 */


(function ($, dis) {
	"use strict";


	dis.Menu = function () {
		dis.BaseModule.call(this);

		var dom = {},
		selfScope = this;

		function hashChange() {
			if (window.location.hash !== "#menu-open") {
				dom.serviceMenuTrigger.prop("checked", false).change();
			}
		}
		var SearchBtn = document.querySelector(".search-header");
		var SearchInputWrapper = document.querySelector(".page-header-search");
		var pageHeader = document.querySelector(".page-header__main");
		var SearchInput = document.querySelector("#main-search-input-header");
		var SearchWrapper = document.querySelector(".main-search");
		var SearchMobilClose = document.querySelector(".search-header-close");
		var SearchClearBtn = document.querySelector(".search-btn-cta-clear");
		var body = document.body;

		function inputSearch() {
			if (SearchInput.value != "" || null) {
				$('#main-search-input-header').addClass("inputActive")
				$(".search-btn-cta-clear").addClass("SearchClearBtnActive")

			} else {
				$('#main-search-input-header').removeClass("inputActive")
				$(".search-btn-cta-clear").removeClass("SearchClearBtnActive")

			}
		}

		function SearchShow() {
			SearchWrapper.classList.toggle("search-header-close-active");
			SearchInputWrapper.classList.toggle("search-show");
			pageHeader.classList.toggle("page-header-search-show");
			SearchInput.focus();
			// if(body.hasClass("menu-open")) {
				dom.serviceMenuTrigger.prop("checked", false).change();
			// }
		}
		function SearchClose() {
			SearchWrapper.classList.toggle("search-header-close-active");
			SearchInputWrapper.classList.toggle("search-show");
			pageHeader.classList.toggle("page-header-search-show");
			// if(body.hasClass("menu-open")) {
			// 	dom.serviceMenuTrigger.prop("checked", false).change();
			// }
		}
		
		function SearchClear() {
			SearchInput.value = "";
			SearchInput.focus();
			$(".search-btn-cta-clear").removeClass("SearchClearBtnActive")
		}

		SearchBtn.addEventListener("click", SearchShow); 
		SearchMobilClose.addEventListener("click", SearchClose); 
		SearchClearBtn.addEventListener("click", SearchClear);
		// SearchInput.addEventListener("change keyup", inputSearch)

		$('#main-search-input-header').on('change keyup', function() {
			inputSearch();  
		  })

		function init() {
			dom.triggers = $("input[name=header-item]");
			dom.serviceMenuTrigger = dom.triggers.filter("#service-menu__trigger");
			dom.serviceMenuTriggerLabel = $("label[for=service-menu__trigger]");
			dom.serviceMenuTriggerLabel.attr('tabindex', 0);

			// Open meny with enter key on focus.
			dom.serviceMenuTriggerLabel.on('focus', function () {
				$(this).on('keydown', function (e) {
					if (e.which === 13) {
						e.stopImmediatePropagation();
						dom.serviceMenuTrigger.click();
					}
				});
			});

			// Close with esc key if open.
			$(window).on('keydown', function (e) {
				if (e.which === 27 && dom.serviceMenuTrigger.is(':checked')) {
					e.stopImmediatePropagation();
					dom.serviceMenuTrigger.click();
				}
			});

			dom.triggers.on("change", function () {
				if (dom.serviceMenuTrigger.is(":checked") && selfScope.currentScreenMode <= 3) {
					// Make sure window is scrolled to top and activate menu
					selfScope.globalDOM.window.scrollTop(0);
					selfScope.currentWindowScrollPosition = 0;
					selfScope.scrollLock.enable();

					// Add class to body
					// setTimeout(
					// 	function() 
					// 	{
					// 		selfScope.globalDOM.body.removeClass("menu-closed");
					// 	}, 400);
					selfScope.globalDOM.body.removeClass("menu-closed");

					selfScope.globalDOM.body.addClass("menu-open");

					// Add hash to URL and listen for changes (history back)
					window.location.hash = "menu-open";
					window.addEventListener("hashchange", hashChange);
				} else {
					// Deactivate menu
					selfScope.scrollLock.disable();

					// Remove class from body
					// setTimeout(
					// 	function() 
					// 	{
					// 		selfScope.globalDOM.body.removeClass("menu-open");
					// 	}, 400);
					selfScope.globalDOM.body.removeClass("menu-open");
					selfScope.globalDOM.body.addClass("menu-closed");
					
					$(".brugerUl .burgerItems").removeClass("parentInActive");
					$(".brugerUl .burgerItems").removeClass("parentActive");
					$(".brugerUl .burgerItems").removeClass("ulactive");
					$(".brugerUl").removeClass("parentInActive");
					$(".brugerUl").removeClass("parentActive");
					$(".burgerItems").css('transform', 'translateX(-0px)')
					$(".testRasmus").css('transform', 'translateX(-0px)')
					$(".brugerUl .brugerBack").removeClass("dontShow");
					$(".brugerUl .prevLink").removeClass("dontShow");
					$(".parentActive .prevLink").removeClass("dontShow")
					$(".parentActive .testRasmus").removeClass("dontShow")
					$(".parentActive .wrapper").removeClass("activeClass") 
					$(".parentActive .testRasmus").removeClass("tetete")
					$(".parentActive .testRasmus").removeClass("ulactive")
					$(".brugerUl .testRasmus").removeClass("tetete")
					$(".brugerUl .ulactive").removeClass("ulactive")
					$(".brugerUl .testRasmus").removeClass("ulactive")
					$(".brugerUl .testRasmus").removeClass("parentActive")
					$(".parentActive").removeClass("tetete")
					$(".parentActive").removeClass("parentActive")
					$(".brugerUl .prevLink").removeClass("dontShow")
					$(".brugerUl .prevLink").removeClass("dontShow")
					$(".parentActive .brugerBack").css('transform', 'translateX(-0px)')
					$(".parentActive .prevLink").css('transform', 'translateX(-0px)')
					$(".parentActive .testRasmus .testRasmus .ulactive").removeClass("ulactive")
					$(".brugerUl .brugerBack").css('transform', 'translateX(-0px)')
					$(".brugerUl .prevLink").css('transform', 'translateX(-0px)')
					$(".brugerUl .testRasmus .testRasmus .ulactive").removeClass("ulactive")
					$(".service-menu__secondary").css('transform', 'translateX(-0px)')
					$(".service-menu__secondary").removeClass("parentInActive")

					// Stop listening for URL changes (history back) and go back if hash is #menu-open
					window.removeEventListener("hashchange", hashChange);
					if (window.location.hash === "#menu-open") {
						window.history.back();
					}
				}
			});

			selfScope.onWindowResize(function () {
				var scrollLockActive = selfScope.scrollLock.state();
				if (selfScope.currentScreenMode > 3 && scrollLockActive) {
					// Close menu when resizing from mobile/tablet to desktop
					dom.serviceMenuTrigger.prop("checked", false).change();
				} else if (selfScope.currentScreenMode <= 3 && !scrollLockActive) {
					// Close menu when resizing from desktop to mobile/tablet
					dom.serviceMenuTrigger.prop("checked", false).change();
				}
			});
		}

		selfScope.onReady(init);
	};

	dis.Menu.prototype = new dis.BaseModule();
	dis.Menu.constructor = dis.Menu;


// This is where you define the global parameters you pass into your closure. You'll want to pass in any
// big stuff you'll need inside your script. Minor stuff can always be accessed through window.someVariable.

	// var fullWidth = $( window ).width();
	burgermenu()
	window.addEventListener("resize", burgermenu)

	function burgermenu() {
		var fullWidth = window.outerWidth
		var newwidthTimeTwo = fullWidth * 2;

		$(".burgerItems").css('width',newwidthTimeTwo + 'px')
		$(".testRasmus").css('width',newwidthTimeTwo + 'px')
		$(".service-menu__secondary").css('width',newwidthTimeTwo + 'px')
		$(".wrapper").css('width',fullWidth + 'px')
		$(".service-menu__target .haschildren  ul").css('width',fullWidth + 'px')
		$(".service-menu__secondary li ").css('width',fullWidth + 'px')
		$(".brugerUl").css('width',fullWidth + 'px')
		$(".headerNext-text").click(function() {
	
			var parntclass = $(this).parent()
			var parntParent = parntclass.parent();
	
			parntclass.addClass("activeClass")
			parntclass.parent().addClass("tetete")
			parntclass.parent().siblings().addClass("dontShow")
			parntclass.siblings("ul").addClass("ulactive")
			parntParent.parent().addClass("parentActive")
			$(".service-menu__secondary").addClass("parentInActive")
			$(".service-menu__secondary").css('transform', 'translateX(-'+ fullWidth +'px)')
			$(".service-menu__secondary li").css('transform', 'translateX(-'+ fullWidth +'px)')
	
			var parentClass = parntParent.parent().prop('className')
	
			if(parentClass == "burgerItems parentActive") {
				$(".burgerItems").addClass("parentInActive")
				parntParent.parent().removeClass("parentInActive")
				$(".parentInActive .testRasmus").css('transform', 'translateX(-'+ fullWidth +'px)')
			}
	
			$(".burgerItems").css('transform', 'translateX(-'+ fullWidth +'px)')
			$(".parentActive").css('transform', 'translateX(-0px)')
			
			parntclass.parent().css('transform', 'translateX(-'+ fullWidth +'px)')
			parntclass.parent().siblings().css('transform', 'translateX(-'+ fullWidth +'px)')
		})
	
		$(".headerNext").click(function() {
	
			var parntclass = $(this).parent()
			var parntParent = parntclass.parent();
	
			parntclass.addClass("activeClass")
			parntclass.parent().addClass("tetete")
			parntclass.parent().siblings().addClass("dontShow")
			parntclass.siblings("ul").addClass("ulactive")
			parntParent.parent().addClass("parentActive")
			$(".service-menu__secondary").addClass("parentInActive")
			$(".service-menu__secondary").css('transform', 'translateX(-'+ fullWidth +'px)')
			$(".service-menu__secondary li").css('transform', 'translateX(-'+ fullWidth +'px)')
	
			var parentClass = parntParent.parent().prop('className')
	
			if(parentClass == "burgerItems parentActive") {
				$(".burgerItems").addClass("parentInActive")
				parntParent.parent().removeClass("parentInActive")
				$(".parentInActive .testRasmus").css('transform', 'translateX(-'+ fullWidth +'px)')
			}
	
			$(".burgerItems").css('transform', 'translateX(-'+ fullWidth +'px)')
			$(".parentActive").css('transform', 'translateX(-0px)')
			
			parntclass.parent().css('transform', 'translateX(-'+ fullWidth +'px)')
			parntclass.parent().siblings().css('transform', 'translateX(-'+ fullWidth +'px)')
		})
	
		$(".brugerBack").click(function() {
			var parntclass = $(this).parent().parent()
			var parentClass = parntclass.parent().prop('className')
			if (parentClass == "burgerItems parentActive") {
				$(".burgerItems").removeClass("parentInActive")
				$(".burgerItems").removeClass("parentActive")
				$(".service-menu__secondary").removeClass("parentInActive")
				setTimeout(
					function() 
					{
						$(".service-menu__secondary").css('transform', 'translateX(-0px)')
						$(".service-menu__secondary li").css('transform', 'translateX(-0px)')
						$(".burgerItems").css('transform', 'translateX(-0px)')
						$(".testRasmus").css('transform', 'translateX(-0px)')
					}, 100);
			} else {
				$(".parentActive .brugerBack").removeClass("dontShow")
				$(".parentActive .prevLink").removeClass("dontShow")
				$(".parentActive .testRasmus").removeClass("dontShow")
				$(".parentActive .wrapper").removeClass("activeClass") 
				$(".parentActive .testRasmus").removeClass("tetete")
				$(".parentActive").removeClass("tetete")
				$(".parentActive .testRasmus .testRasmus .ulactive").removeClass("ulactive")
				setTimeout(
					function() 
					{
						$(".parentActive .testRasmus .testRasmus").css('transform', 'translateX(-0px)')
						$(".parentActive .brugerBack").css('transform', 'translateX(-0px)')
						$(".parentActive .prevLink").css('transform', 'translateX(-0px)')
						$(".service-menu__secondary").css('transform', 'translateX(-0px)')
					}, 100);
	
				var parntclass = $(this).parent()
				var parntParent = parntclass.parent();
	
			parntclass.removeClass("activeClass")
			parntclass.parent().removeClass("tetete")
			parntclass.parent().siblings().removeClass("dontShow")
			parntclass.siblings("ul").removeClass("ulactive")
			parntParent.parent().removeClass("parentActive")
			}
		})
		  
	}



	

}(jQuery, dis));
